import { B as c } from "./ButtonBase-a1MtCiSI.js";
import { i as s } from "./lit-element-6iugfgmM.js";
class e extends c {
}
const n = s`
    
`, t = s`
    .spectrum-UIIcon-Cross75{--spectrum-icon-size:var(--system-ui-icon-cross-75-icon-size)}.spectrum-UIIcon-Cross100{--spectrum-icon-size:var(--system-ui-icon-cross-100-icon-size)}.spectrum-UIIcon-Cross200{--spectrum-icon-size:var(--system-ui-icon-cross-200-icon-size)}.spectrum-UIIcon-Cross300{--spectrum-icon-size:var(--system-ui-icon-cross-300-icon-size)}.spectrum-UIIcon-Cross400{--spectrum-icon-size:var(--system-ui-icon-cross-400-icon-size)}.spectrum-UIIcon-Cross500{--spectrum-icon-size:var(--system-ui-icon-cross-500-icon-size)}.spectrum-UIIcon-Cross600{--spectrum-icon-size:var(--system-ui-icon-cross-600-icon-size)}
`;
export {
  e as S,
  t as c,
  n as t
};
//# sourceMappingURL=icon-cross-overrides.css-ByfvfcHs.js.map
